export default __webpack_public_path__ + "signal-bars.png";